import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import PlanoGovernoService from "../../services/http/services/PlanoGovernoService";
import { IMunicipio, IPlanoGovernoAnexo, IPlanoGovernoEixo } from "./interfaces";
import { useNavigate } from "react-router-dom";
import { EmitError } from "../../utils/EmitError";
import { Modal } from "antd";
import toast from "../../utils/toast";
import InstitucionalService from "../../services/http/services/InstitucionalService";
import useAuth from "../../hooks/useAuth";


export default function usePlanoDeGoverno() {

    const navigate = useNavigate();

    const { userCan } = useAuth();

    const refDataEntity = useRef(
        JSON.parse(localStorage.getItem("@GovfacilGestor:selectedEntity")!) || null
    );

    const refSumAbreModalAnexos = useRef('notreq');

    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingEixos, setIsLoadingEixos] = useState(false);
    const [isLoadingAnexos, setIsLoadingAxenos] = useState(false);
    const [isLoadingMunicipios, setIsLoadingMunicipios] = useState(false);

    const [municipios, setMunicipios] = useState<IMunicipio[]>();
    const [eixos, setEixos] = useState<IPlanoGovernoEixo[]>([]);
    const [anexos, setAnexos] = useState<IPlanoGovernoAnexo[]>([]);
    const [openModalAnexos, setOpenModalAnexos] = useState<boolean>(false);
    const refContagemDoFiltro = useRef<Array<any>>([]);
    const controller = new AbortController();
    const [citySelected, setCitySelected] = useState<string>();
    const [isEditarAnexo, setIsEditarAnexo] = useState<boolean>(false);
    const [anexoSelected, setAnexoSelected] = useState<IPlanoGovernoAnexo | undefined>();

    useEffect((): void => {
        if (!openModalAnexos) {

            if (refSumAbreModalAnexos.current === 'getAnexos') getAnexos();
            refSumAbreModalAnexos.current = 'notreq'

        }
    }, [openModalAnexos]);

    const handleSaveAnexo = useCallback(() => {

        refSumAbreModalAnexos.current = 'getAnexos'
        // Promise.all([getAnexos()]);

        setOpenModalAnexos(false);
    }, []);

    const handleChangeCitySelected = useCallback((city: string) => {
        const idIbge = city.split('-')[1];
        setCitySelected(idIbge);
    }, []);

    const handleCreateOrEditEixo = useCallback((uuid?: string) => {
        if (uuid) {
            return navigate(`/plano-de-governo/eixo/editar/${uuid}`)
        }
        return navigate('/plano-de-governo/eixo/cadastrar');
    }, []);

    const handleCreateOrEditAnexo = useCallback((uuid?: string) => {

        setIsEditarAnexo(uuid ? true : false);

        if (uuid) {
            const selectedAnexo = anexos.find((anexo) => anexo.uuid === uuid);
            setAnexoSelected(selectedAnexo);
        }

        setOpenModalAnexos((prevState) => {
            // if (prevState) {
            //     refSumAbreModalAnexos.current = 'getAnexos'
            // } else {
            // }
            return !prevState
        });

    }, [anexos]);


    const onClickExcluirAnexo = useCallback((uuid: string) => {
        try {
            //Confirmação de exclusão
            Modal.confirm({
                title: "Excluir anexo",
                content:
                    "Deseja realmente excluir o anexo? (Essa ação não pode ser desfeita)",
                okText: "Sim",
                cancelText: "Não",
                onOk() {
                    setIsLoading(true);
                    PlanoGovernoService.deleteAnexoByUuid(uuid).then((result) => {
                        toast({
                            type: 'success',
                            text: 'Anexo excluído com sucesso!',
                            duration: 5000,
                        });
                        getAnexos();
                        setIsLoading(false);
                    }).catch(() => {
                        setIsLoading(false)
                    });
                },
                onCancel() { },
            });
        } catch (error) {
            EmitError(error, true, "useEffect");
        }
    }, [eixos]);

    const onClickExcluirEixo = useCallback((uuid: string) => {
        try {
            //Confirmação de exclusão
            Modal.confirm({
                title: "Excluir eixo",
                content:
                    "Deseja realmente excluir o eixo? (Essa ação não pode ser desfeita)",
                okText: "Sim",
                cancelText: "Não",
                onOk() {
                    setIsLoading(true);
                    PlanoGovernoService.deleteEixoByUuid(uuid).then((result) => {
                        toast({
                            type: 'success',
                            text: 'Eixo excluído com sucesso!',
                            duration: 5000,
                        });
                        getEixos();
                        setIsLoading(false);
                    }).catch(() => {

                        setIsLoading(false);
                    });
                },
                onCancel() { },
            });
        } catch (error) {
            EmitError(error, true, "useEffect");
        }
    }, [eixos]);

    const getEixos = useCallback(() => {
        const buscaDeDados = async () => {
            try {
                if (!citySelected) {
                    return;
                }
                setIsLoadingEixos(true);
                let eixos = await PlanoGovernoService.getEixosByIdIbge(Number(citySelected), controller.signal);

                eixos.sort((a: any, b: any) => {
                    return (
                        moment(b.created_at).unix() -
                        moment(a.created_at).unix()
                    );
                });
                setEixos(eixos);
                setIsLoadingEixos(false);
            } catch (error) {
                // EmitError(error, true, "useEffect");
                setIsLoadingEixos(false);
            }
        };
        return buscaDeDados();
    }, [citySelected]);

    const getAnexos = useCallback(() => {
        const buscaDeDados = async () => {
            try {
                if (!citySelected) {
                    return;
                }
                setIsLoadingAxenos(true);
                let anexos = await PlanoGovernoService.getAnexosByIdIbge(Number(citySelected), controller.signal);

                anexos.sort((a: any, b: any) => {
                    return (
                        moment(b.created_at).unix() -
                        moment(a.created_at).unix()
                    );
                });
                setAnexos(anexos);
                setIsLoadingAxenos(false);
            } catch (error) {
                // EmitError(error, true, "useEffect");
                setIsLoadingAxenos(false);
            }
        };

        return buscaDeDados();
    }, [citySelected]);

    const getMunicipios = useCallback(() => {
        const buscaDeDados = async () => {
            try {

                setIsLoadingMunicipios(true);
                const data = await InstitucionalService.getGestorEntidade(refDataEntity.current?.entity?.id, controller.signal)


                let municipio = await PlanoGovernoService.getMunicipiosDoContrato(data.contractId, controller.signal);

                // let municipio2 = await PlanoGovernoService.getMunicipios(controller.signal);

                municipio.sort((a: any, b: any) => a.nome.localeCompare(b.nome));

                setMunicipios(municipio);

                setIsLoadingMunicipios(false);
            } catch (error) {
                EmitError(error, true, "useEffect");
                setIsLoadingMunicipios(false);
            }
        };
        return buscaDeDados();
    }, []);


    const cityOptionSelected = useMemo(() => {
        if (!citySelected) {
            return undefined;
        }
        const city = municipios?.find((municipio) => municipio.idIbge === Number(citySelected));
        if (!city) {
            return undefined;
        }

        return city.nome + ' - ' + city.estado;
    }, [municipios, citySelected]);

    useMemo(() => {

        if (userCan('manage_government_plan')) {

            getEixos();
            getAnexos();
            if (citySelected) {
                localStorage.setItem('@GovfacilGestor:citySelected', citySelected);
            }

        }
    }, [citySelected])

    useEffect((): void => {

        if (userCan('manage_government_plan')) {
            getEixos();
            getAnexos();
            getMunicipios();
        }
    }, []);

    useEffect(() => {
        let city = localStorage.getItem("@GovfacilGestor:citySelected");

        if (city) {
            setCitySelected(city);
        }
    }, []);

    return {
        eixos,
        isLoading,
        refContagemDoFiltro,
        handleCreateOrEditEixo,
        onClickExcluirEixo,
        onClickExcluirAnexo,
        handleCreateOrEditAnexo,
        handleChangeCitySelected,
        citySelected,
        municipios,
        cityOptionSelected,
        anexos,
        openModalAnexos,
        handleSaveAnexo,
        isEditarAnexo,
        anexoSelected,
        isLoadingEixos,
        isLoadingAnexos,
        isLoadingMunicipios,
        userCan,
    };
}
